import {createFileRoute} from '@tanstack/react-router';

import {EventsHistoryView} from '@/features/events/views/events-history-view';

export const Route = createFileRoute('/_app/settings/events')({
  component: EventsHistoryView,
  beforeLoad() {
    return {
      title: 'Event History',
      breadcrumb: {
        label: 'Events',
      },
    };
  },
});
